function __match(v,ex){if(ex===null)return v===null;if(ex===undefined)return true;const t=typeof ex;if(t==='string'||t==='number'||t==='boolean')return typeof v===t;if(Array.isArray(ex)){if(!Array.isArray(v))return false;return ex.length?v.every(x=>__match(x,ex[0])):true}if(t==='object'){if(!v||typeof v!=='object'||Array.isArray(v))return false;return Object.keys(ex).every(k=>k in v&&__match(v[k],ex[k]))}return v===ex};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.__ex=ex;t.check=v=>__match(v,ex)}return t};
function FunctionPredicate(n,s,b){if(Array.isArray(s)&&b){const f=(...a)=>FunctionPredicate(n,b(...a));f.typeParamNames=s.map(p=>Array.isArray(p)?p[0]:p);f.description=n;f.__runtimeType=true;return f}const spec=typeof s==='function'?{}:s||{};return{description:n,params:spec.params||{},returns:spec.returns,returnContract:spec.returnContract||'assertReturns',check:v=>typeof v==='function',__runtimeType:true}};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type,FunctionPredicate};
/* tjs <- registry.ts */

import { XinObject, XinProxy, XinBinding } from './xin-types'

export const registry = {};

let _xin = null;

/* line 12 */
/* TODO: TS types degraded — xin: XinProxy<XinObject> */
export function setXinProxy(xin) {
    _xin = xin;
}
setXinProxy.__tjs = {
  "params": {
    "xin": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "registry.ts:11"
}

/* line 16 */
/* TODO: TS types degraded — return: XinProxy<XinObject> */
export function getXinProxy() {
    if (_xin === null) {
        throw new Error('xin proxy not initialized');
    }
    return _xin;
}
getXinProxy.__tjs = {
  "params": {},
  "unsafe": true,
  "source": "registry.ts:17"
}

const BindFunc = FunctionPredicate('BindFunc', { params: { element: {}, path: '', binding: null, options: null } })

const OnFunc = Type('OnFunc')

let _bind = null;

let _on = null;

/* line 37 */
/* TODO: TS types degraded — on: OnFunc */
export function setBindFunctions(bind, on) {
    _bind = bind;
    _on = on;
}
setBindFunctions.__tjs = {
  "params": {
    "bind": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    },
    "on": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "unsafe": true,
  "source": "registry.ts:34"
}

/* line 42 */
export function getBind() {
    if (_bind === null) {
        throw new Error('bind not initialized');
    }
    return _bind;
}
getBind.__tjs = {
  "params": {},
  "returns": {
    "type": {
      "kind": "any"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "registry.ts:40"
}

/* line 49 */
/* TODO: TS types degraded — return: OnFunc */
export function getOn() {
    if (_on === null) {
        throw new Error('on not initialized');
    }
    return _on;
}
getOn.__tjs = {
  "params": {},
  "unsafe": true,
  "source": "registry.ts:49"
}